<template>
<div>
    <div class="menuForme g_desktopOn">
        <div style="display: inline-block;margin-top: 5px;width:80%"  v-if="nav=='joueur'" >
        
        <s-button 
                @onclick="nav='equipe'" 
                icon="user-friends"
                theme="is-primary" label="Liste des équipes"
                v-show="nav=='joueur'"/>&nbsp;
            <div style="display: inline-block;" v-if="nav=='joueur' && !alea">
         <s-button 
                @onclick="createTeam" 
                icon="link"
                theme="is-primary" label="Former une équipe"
                :disabled="joueurMeneur==null && nav=='joueur'"
                
            />&nbsp;
            </div>
         <div style="display: inline-block;" v-if="nav=='joueur' && alea" >
            <s-button 
                @onclick="generateTeamsAlea" 
                icon="recycle"
                theme="is-success" label="Générer les équipes" 
                v-if="nav=='joueur' && alea"
            />
        </div>
        </div>
        
        <div style="display: inline-block;margin-top: 30px;"  v-if="nav=='equipe'" >
        
            <s-button 
                @onclick="createTeam" 
                icon="link"
                theme="is-primary" label="Former une équipe"
                :disabled="joueurMeneur==null && nav=='joueur'"
             
            />&nbsp;
        
            <s-button 
                    @onclick="createTeamsAlea" 
                    icon="users-cog"
                    theme="is-primary" label="Créer des équipes aléatoires"
                    :disabled="joueurMeneur==null && nav=='joueur'"
             
                />&nbsp;
           <div style="margin:5px">
            <s-button 
                    @onclick="createOneTeam" 
                    icon="plus"
                    theme="is-primary" label="Créer une équipe simplifiée"
                    :disabled="joueurMeneur==null && nav=='joueur'"
                   
                />&nbsp;
           </div>
   
        </div>
       
        
          
    </div>
    <div class="g_menuMobile">
        <table class="g_menuFooterMin">
            <tr>
                <td colspan="5" class="g_headerFooter" >
                </td>
            </tr>
            <tr>
                <td>
                    <s-button theme="is-primary" icon="sync" @onclick="createTeamsAlea" label="Aléatoire" mode="V"/>
                </td>
               
                <td>
                    <s-button theme="is-primary"  icon="link" @onclick="createTeam" label="Former une équipe" mode="V"/>
                </td>
                 <td>
                    <s-button theme="is-primary"  icon="plus" @onclick="createOneTeam" label="Créer une équipe" mode="V"/>
                </td>
                 <td>
                    <s-button theme="is-primary"  icon="cog" @onclick="$emit('openConfig')" label="Configurer" mode="V"/>
                </td>
                <td>
                    <s-button theme="is-success"  icon="play" @onclick="$emit('start')" label="Démarrer" mode="V"/>
                </td>
            </tr>
        </table>
    </div>
    <div v-if="nav=='joueur'" class="listEquipes">
        <joueur-vue
            :club="club"
            :tournoi="tournoi"
            role="owner"
            v-if="club.id!=''"
            :meneur="joueurMeneur"
            :options="{inscription: true, forme: true}"
            @setMeneur="setMeneur"
            @setNav="setNav"
            @openEquipe="openEquipe"
            @deleteEquipe="deleteEquipe"
            @createTeam="createTeam"
            :equipes="equipes"
            @generate="generateTeamsAlea"
            @addAnonymes="addJoueursInvites"
            :alea= "alea"
            ref="joueurVue"
        />
    </div>
    <div v-if="nav=='equipe'" class="listEquipes" >
        <div v-if="equipes.length==0" >
                <div class="notification is-info">
                    Aucune équipe inscrite pour le moment ... <br/>
                    Cliquez sur <b>Créer une équipe</b> ...
                </div>

        </div>
        <div v-for="(joueur, index) in equipes" class="equipeItem">   
                <equipe-item
                    :joueur="joueur"
                    :tournoi="tournoi"
                    :role="role"
                    :index="index"
                    :club="club"
                    @save="save"
                    @openEquipe="openEquipe"
                    @deleteEquipe="deleteEquipe"
                />
        </div>
    </div>
      <s-modal-code
            :open="openConfirmCode"
            :club="club"
            @close="openConfirmCode=false"
            @valid="openInscription(this.tournoiSelected)"
        />
    <create-team-vue
        :open="modalCreateOneTeam"
        :tournoi="tournoi"
        :club="club"
        @close="modalCreateOneTeam=false"
    />
</div>
</template>
<style scoped>
    .equipeItem {
        display:inline-block;
        vertical-align: top;
    }
    .menuForme {
        width: 500px;
        height: 10px;
        position: fixed;
        top:47px;
        padding-top: 10px;
        z-index: 2;
        left: 0px;
        
    }
    @media screen and (max-width: 420px) {  
        .listEquipes {
            margin-top: 80px;
            margin-bottom: 100px;
        }

    }
    @media screen and (min-width: 420px) {  
        .listEquipes {
            margin-top: 200px;
            
        }
    }
</style>
<script>
import JoueurVue from "@/views/joueurs/list.vue"
import equipeItem from "@/views/tournoi/equipeItem.vue"
import createTeamVue from "@/views/tournoi/inscription/createTeam.vue"
export default {
    props: ["club", "tournoi",'role','meneur'],
    components: {
        JoueurVue,
        equipeItem,
        createTeamVue
    },
    computed: {
        equipes: {
            get() {
                var equipes=[];
                this.tournoi.joueurs.forEach(joueur=>{
                    
                    if (joueur.meneur) {
                        equipes.push(joueur);
                    }
                })
                
                return equipes;
            }
        }
    },
    mounted() {
        if (this.nav=="joueur") 
                this.$emit("disabledStart", true);
            else
                this.$emit("disabledStart", false);
    },
    watch: {
        nav(val) {
            if (val=="joueur") 
                this.$emit("disabledStart", true);
            else
                this.$emit("disabledStart", false);
        }
    },
    data() {
        return {
            nav: this.tournoi.options.melee ? "joueur" : "equipe",
            joueurMeneur: null,
            alea: this.tournoi.options.melee ? true : false,
            openConfirmCode: false,
            modalCreateOneTeam: false
        }
    },
    methods: {
        refresh() {
             if (typeof(this.$refs.joueurVue)!="undefined")
                    this.$refs.joueurVue.refresh();
        },
        
        addJoueursInvites(nbJoueursAnonymes) {
           
           this.$emit("addAnonymes", nbJoueursAnonymes)
        },
        deleteEquipe(meneur) {
            
             var indexJoueur = this.tournoi.joueurs.findIndex(joueurTempo=>joueurTempo.id===meneur.id);
           
            if (indexJoueur!=-1) {
                var joueur = this.tournoi.joueurs[indexJoueur];
            
                if (joueur.coequipier1 != null) {
                
                    var indexJoueur1 = this.tournoi.joueurs.findIndex(joueurTempo=>joueurTempo.id===joueur.coequipier1);
                
                    if (indexJoueur1 != -1) {
                       this.tournoi.joueurs.splice(indexJoueur1, 1);
                    }

                }
                if (joueur.coequipier2 != null) {
                    var indexJoueur2 = this.tournoi.joueurs.findIndex(joueurTempo=>joueurTempo.id===joueur.coequipier2);
                    if (indexJoueur2 != -1) {
                        this.tournoi.joueurs.splice(indexJoueur2, 1);
                    }
                }
                this.tournoi.joueurs.splice(indexJoueur, 1);
                if (this.nav=='joueur')
                    this.createTeam();
                this.save();
               
            }
        },
        cancel() {
        
            var tabDelete = [];
            this.tournoi.joueurs.forEach((joueur, index)=>{
                var notCoequipier = this.tournoi.joueurs.findIndex(joueurTempo=>joueurTempo.coequipier1 === joueur.id) == -1
                 if (notCoequipier)
                    notCoequipier = this.tournoi.joueurs.findIndex(joueurTempo=>joueurTempo.coequipier2 === joueur.id) == -1
                if (notCoequipier && typeof(joueur.meneur)=='undefined')
                    tabDelete.push(joueur.id);
                else if (notCoequipier && !joueur.meneur)
                    tabDelete.push(joueur.id);
            });
            tabDelete.forEach(idJoueur=>{
                var indexJoueur = this.tournoi.joueurs.findIndex(joueurTempo=>joueurTempo.id === idJoueur);
                this.tournoi.joueurs.splice(indexJoueur, 1);
            })
        
            this.$emit("save",this.tournoi);
            this.nav='equipe';
        },
        random(min, max) {
            return Math.floor(min + Math.random() * (max - min));
        },
        generateTeamsAlea() {
            
            var listJoueursRestant = [];
            this.tournoi.joueurs.forEach((joueur, index)=>{
                var notCoequipier = this.tournoi.joueurs.findIndex(joueurTempo=>joueurTempo.coequipier1 === joueur.id) == -1
                 if (notCoequipier)
                    notCoequipier = this.tournoi.joueurs.findIndex(joueurTempo=>joueurTempo.coequipier2 === joueur.id) == -1
                if (notCoequipier && typeof(joueur.meneur)=='undefined')
                    listJoueursRestant.push(index);
            })
           
            var nbJoueurs = listJoueursRestant.length / this.tournoi.options.nbJoueursParEquipe;
           
            for (var indexJoueur= 0; indexJoueur < nbJoueurs ; indexJoueur++) {
                // random d'un numero
                var indexRandom = this.random(0, listJoueursRestant.length);
                var numeroRandom = listJoueursRestant[indexRandom];
                this.tournoi.joueurs[numeroRandom].meneur = true;
               
                
              listJoueursRestant.splice(indexRandom, 1);
               
               
            }
            // le reste ce sont des coequipiers
       
            var i=0;
            this.tournoi.joueurs.forEach((joueur, indexJoueur)=>{
              
                 if (joueur.meneur &&  listJoueursRestant.length>0) {
                    for (var nbJoueur=1;nbJoueur<this.tournoi.options.nbJoueursParEquipe;nbJoueur++) {
                        if ((joueur.coequipier1 == null && nbJoueur==1) || (joueur.coequipier2 == null && nbJoueur==2)) {
                            var indexRandom = this.random(0, listJoueursRestant.length);
                            var numeroRandom = listJoueursRestant[indexRandom];
                            if (nbJoueur == 1) {
                                joueur.coequipier1 = this.tournoi.joueurs[numeroRandom].id;
                                joueur.coequipier2 = null;
                            }   
                            if (nbJoueur == 2)
                                joueur.coequipier2 = this.tournoi.joueurs[numeroRandom].id;
                            listJoueursRestant.splice(indexRandom, 1);
                        }
                    }
                        
                 }
                 
                 
            })
            var refreshJoueurs = [];
             this.tournoi.joueurs.forEach((joueur, indexJoueur)=>{
                 refreshJoueurs.push(JSON.parse(JSON.stringify(joueur)))
             });

            this.tournoi.joueurs = [];
            refreshJoueurs.forEach(joueur=>{
                if (joueur.meneur)
                    this.tournoi.joueurs.push(joueur);
            })
            refreshJoueurs.forEach(joueur=>{
                if (!joueur.meneur)
                    this.tournoi.joueurs.push(joueur);
            })
            
            this.nav="equipe";
            this.$emit("save",this.tournoi);
        },
        createTeamsAlea() {
             this.alea = true;
             this.joueurMeneur = null;
             this.nav='joueur';
        },
        createOneTeam() {
            this.modalCreateOneTeam = true;
        },
        createTeam() {
            this.joueurMeneur = null;
            this.alea = false;
            this.nav='joueur';
             /*
             var demo = this.$store.getters.getDemo;
            if (demo.active) {
                demo.equipeCompleted = this.meneur!=null;
                if (demo.equipeCompleted)
                    demo.nbEquipes++;
                this.$store.dispatch("setUpdateDemo", demo);
            }*/
        },
        setMeneur(joueur) {
            this.joueurMeneur = joueur;
        },
        setNav(nav) {
            this.alea = false;
            this.nav=nav;
        },
        isMeneur(joueur) {
            if (this.tournoi.options.mode == "FORME") {
                return joueur.meneur;
            }
            else
                return true
        },
        
        save(tournoi) {
            this.$emit("save", tournoi);
        },
        openEquipe(joueur) {
             
             this.alea = false;
             this.joueurMeneur = joueur;
             this.nav="joueur";
        }
    }
}
</script>